import React, { useContext } from 'react';
import { ActivityIndicator as RNActivityIndicator, ActivityIndicatorProps } from 'react-native';
import { ThemeContext } from '..';

export const ActivityIndicator = (props: ActivityIndicatorProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);

  return <RNActivityIndicator {...props} color={props.color || theme.colors.gray.normal} />;
};
